module.exports = __webpack_public_path__ + "img/new-sor-color.ec2bc1a4.png";